import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/integrations/axios/axios-instance'

type UseExportPdfQueryProps = {
  isOpen: boolean
  type: 'donation' | 'annual'
  donor: any
  donation?: any
  memberId?: string | null
  summaryYear: number | null
  enabled?: boolean
}

export function useExportPdfQuery({
  isOpen,
  type,
  donor,
  donation,
  memberId,
  summaryYear,
  enabled = true,
}: UseExportPdfQueryProps) {
  const queryKey = [
    'export-pdf',
    type,
    type === 'donation' ? donation?._id : memberId,
    memberId,
    ...(type === 'annual' ? [summaryYear] : []),
  ]

  const queryResult = useQuery({
    queryKey,
    queryFn: async () => {
      if (!donor) return null
      if (type === 'donation') {
        if (!donation) return null
        const res = await axiosInstance.get(
          `/export/donation/${donation._id}`,
          { responseType: 'blob' },
        )
        return res.data as Blob
      }

      if (!memberId || summaryYear === null) return null
      const res = await axiosInstance.get(
        `/export/annual-summary/${donor._id}/${summaryYear}`,
        { responseType: 'blob' },
      )
      return res.data as Blob
    },
    enabled:
      enabled &&
      isOpen &&
      !!donor &&
      ((type === 'donation' && !!donation) ||
        (type === 'annual' && !!memberId && summaryYear !== null)),
    staleTime: 1000 * 60 * 60, // 1 hour
  })

  return {
    ...queryResult,
  }
}
